<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-40px">
          <h1 class="title is-size-3">
            {{ $t('echeancierFacturation.popUpDateFacturation.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content ">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="[]"
                           :champsVide="[]"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"/>
      <div class="columns is-multiline">
        <p class="column is-12">
          {{ $t('echeancierFacturation.popUpDateFacturation.indication') }}
        </p>
        <div class="column is-narrow">
          <b-field
            :label="$t('echeancierFacturation.popUpDateFacturation.dateFacturation')"
            class="obligatoire">
            <b-datepicker show-week-number
                          v-model="dateFacturation"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          editable>

            </b-datepicker>
          </b-field>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="updateDateFacturation">
              {{ $t('general.button.edit') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    echeancierLignes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dateFacturation: new Date(),
      messages: [],
      error: false,
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    updateDateFacturation() {
      if (this.dateFacturation && this.dateFacturation !== undefined) {
        this.$emit('updateDateFacturation', this.dateFacturation);
      }
      this.messages.push({ message: this.$t('echeancierFacturation.popUpDateFacturation.error') });
      this.error = true;
    },
  },
  mounted() {
    const datesDebut = this.echeancierLignes
      .filter(echeancier => {
        return echeancier.quantitePeriodicite === 0
        && !echeancier.echeancierLignes.some(l => l.facturationFaite);
      })
      .map(echeance => echeance.dateDebut)
      .sort((a, b) => a - b);
    if (datesDebut.length > 1) this.dateFacturation = datesDebut[0];
  },
};
</script>
